import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/specials";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const [paused, setPaused] = useState(false);

  useEffect(() => {
    if (paused) return;
    const timer = window.setInterval(() => {
      setIndex((prev) => (prev + 1) % heroSlides.length);
    }, 6500);
    return () => window.clearInterval(timer);
  }, [paused]);

  return (
    <section
      className="relative isolate -mt-[72px] w-full overflow-hidden bg-primary-950"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
      aria-roledescription="carousel"
      aria-label="首页焦点推荐"
    >
      <div className="relative h-[560px] w-full md:h-[640px] lg:h-[700px]">
        {heroSlides.map((slide, slideIndex) => (
          <div
            key={slide.id}
            className={`absolute inset-0 transition-opacity duration-1000 ease-smooth ${
              slideIndex === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
            aria-hidden={slideIndex !== index}
          >
            <img
              src={slide.image}
              alt={`${slide.title}焦点推荐图`}
              title={`${slide.title} 午夜影院`}
              className="h-full w-full object-cover object-center"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/80 to-primary-950/25" />
            <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-primary-950 to-transparent" />
          </div>
        ))}

        <div className="relative z-10 flex h-full w-full items-center px-4 pb-16 pt-[72px] md:px-6 xl:px-10">
          <div className="w-full max-w-[1280px]">
            {heroSlides.map((slide, slideIndex) => (
              <div
                key={slide.id}
                className={`max-w-xl transition-all duration-700 ease-smooth ${
                  slideIndex === index
                    ? "translate-y-0 opacity-100"
                    : "pointer-events-none absolute translate-y-4 opacity-0"
                }`}
              >
                <p className="flex items-center gap-2 font-label text-[11px] font-semibold uppercase tracking-[0.24em] text-secondary-400">
                  <span className="h-[2px] w-8 bg-accent-500" />
                  {slide.kicker}
                </p>
                <h1 className="mt-4 font-heading text-4xl font-semibold leading-tight tracking-tight text-background-50 md:text-5xl lg:text-6xl">
                  {slide.title}
                </h1>
                <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-200/90 md:text-base">
                  {slide.subtitle}
                </p>
                <p className="mt-4 font-label text-xs tracking-wide text-background-300/80">
                  {slide.meta}
                </p>
                <div className="mt-8 flex flex-wrap items-center gap-3">
                  <Link
                    to={slide.link}
                    className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-3 text-sm font-medium text-primary-950 transition-colors duration-300 hover:bg-accent-400"
                  >
                    查看详情
                    <i className="ri-arrow-right-line" />
                  </Link>
                  <Link
                    to="/category/movie"
                    className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-3 text-sm text-background-100 transition-colors duration-300 hover:border-secondary-400 hover:text-secondary-300"
                  >
                    浏览全部影片
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="absolute inset-x-0 bottom-8 z-20 flex w-full items-center justify-between gap-4 px-4 md:px-6 xl:px-10">
          <div className="flex w-full max-w-[1280px] items-end justify-between gap-6">
            <div className="flex items-center gap-2">
              {heroSlides.map((slide, slideIndex) => (
                <button
                  key={slide.id}
                  type="button"
                  onClick={() => setIndex(slideIndex)}
                  aria-label={`切换到${slide.title}`}
                  aria-current={slideIndex === index}
                  className={`h-[3px] cursor-pointer rounded-full transition-all duration-500 ${
                    slideIndex === index
                      ? "w-10 bg-accent-500"
                      : "w-5 bg-background-50/35 hover:bg-background-50/60"
                  }`}
                />
              ))}
            </div>

            <div className="hidden items-center gap-3 md:flex">
              <button
                type="button"
                onClick={() => setIndex((prev) => (prev - 1 + heroSlides.length) % heroSlides.length)}
                aria-label="上一张"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-100 transition-colors duration-300 hover:border-secondary-400 hover:text-secondary-300"
              >
                <i className="ri-arrow-left-s-line" />
              </button>
              <span className="font-label text-xs text-background-300">
                {String(index + 1).padStart(2, "0")} / {String(heroSlides.length).padStart(2, "0")}
              </span>
              <button
                type="button"
                onClick={() => setIndex((prev) => (prev + 1) % heroSlides.length)}
                aria-label="下一张"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-full border border-background-50/30 text-background-100 transition-colors duration-300 hover:border-secondary-400 hover:text-secondary-300"
              >
                <i className="ri-arrow-right-s-line" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}